export const CountiesArea = `
Bedfordshire,1235km²,1235
Berkshire,1262km²,1262
Bristol,110km²,110
Buckinghamshire,1874km²,1874
Cambridgeshire,3389km²,3389
Cheshire,2344km²,2344
City of London,3km²,3
Cornwall,3563km²,3563
Cumbria,6768km²,6768
Derbyshire,2625km²,2625
Devon,6707km²,6707
Dorset,2653km²,2653
Durham,2721km²,2721
East Riding of Yorkshire,2479km²,2479
East Sussex,1792km²,1792
Essex,3670km²,3670
Gloucestershire,3150km²,3150
Greater London,1572km²,1572
Greater Manchester,1276km²,1276
Hampshire,3769km²,3769
Herefordshire,2180km²,2180
Hertfordshire,1643km²,1643
Isle of Wight,380km²,380
Kent,3736km²,3736
Lancashire,3079km²,3079
Leicestershire,2156km²,2156
Lincolnshire,6959km²,6959
Merseyside,645km²,645
Norfolk,5371km²,5371
North Yorkshire,8654km²,8654
Northamptonshire,2364km²,2364
Northumberland,5013km²,5013
Nottinghamshire,2161km²,2161
Oxfordshire,2605km²,2605
Rutland,382km²,382
Shropshire,3487km²,3487
Somerset,4171km²,4171
South Yorkshire,1552km²,1552
Staffordshire,2713km²,2713
Suffolk,3798km²,3798
Surrey,1663km²,1663
Tyne & Wear,540km²,540
Warwickshire,1975km²,1975
West Midlands,902km²,902
West Sussex,1991km²,1991
West Yorkshire,2029km²,2029
Wiltshire,3485km²,3485
Worcestershire,1741km²,1741
    `;